<template>
	<section>
		<b-row v-if="apiType =='jayride'">
			<b-overlay :show="loading" no-wrap rounded></b-overlay>
			<b-col cols="12">
				<b-alert show variant="info" class="d-flex justify-content-between">
					<strong>{{apiType}} Reference: {{reference}} </strong>
					<div>
						<b-badge :variant="statusColor">{{bookingStatus}}</b-badge> <strong>| Api {{apiType}}</strong>
						<b-button size="sm" class="ml-1" variant="info" v-b-tooltip.hover title="Información del proveedor" v-if="apiType == 'Jayride'" v-b-modal.modal-supplierInfo><md-icon icon="local_taxi"/></b-button>
					</div>
				</b-alert>
			</b-col>
			<b-col cols="12 text-right">
				<p v-if="bookingStatus === 'canceled'" class="small text-left"><strong>Reserva cancelada por:</strong> {{cancelUser}} | {{cancelDatetime}} (Cancelación unicamente con API)</p>
				<b-button size="sm" variant="danger" class="mb-3" @click="()=>{showConfirmation=true}" v-if="reference && bookingStatus === 'active'">Cancelar reserva</b-button>
			</b-col>
			<b-col cols="12">
				<b-alert show variant="secondary">
					<pre>{{bookingInfo}}</pre>
				</b-alert>
			</b-col>

			<b-modal id="modal-supplierInfo" hide-header hide-footer>
				<b-row>
					<b-col cols="12">
						<small class="text-muted bg-light px-1">Información del proveedor</small>
						<h4 class="mb-1">{{supplierData.name}} <small class="text-muted">(ID: {{supplierData.id}})</small></h4>
						<p class="small mb-0"><md-icon class="text-secondary" icon="alternate_email"/>: <a :href="`mailto:${supplierData.email}`">{{supplierData.email}}</a> </p>
						<p class="small mb-0"><md-icon class="text-secondary" icon="call"/>: {{supplierData.phone}}</p>
						<hr>
						<p class="small mb-2"><md-icon class="text-info" icon="info"/>: {{supplierData.description}}</p>
						<b-button size="sm" @click="$bvModal.hide('modal-supplierInfo')">Cerrar</b-button>
					</b-col>
				</b-row>
			</b-modal>

			<b-overlay no-center :show="showConfirmation" no-wrap>
				<template #overlay>
					<b-overlay :show="loadingConfirmation"></b-overlay>
					<div  v-if="!loadingConfirmation" class="mt-5 pt-3">
						<p class="text-center">
							<strong id="form-confirm-label">¿Desea continuar?</strong>
						</p>
						<p class="text-center">¿Está seguro de que desea cancelar esta reservación de {{apiType}}? <br> Esto cancelará la reserva con {{apiType}}, sin embargo quedará activa en este sistema.</p>
						<div class="text-center">
							<b-button variant="outline-danger" class="mr-3" @click="()=>{showConfirmation=false}">Cancelar</b-button>
							<b-button variant="outline-success" @click="cancelReservation">Confirmar</b-button>
						</div>
					</div>

				</template>
			</b-overlay>
		</b-row>
		<b-row v-else>
			<b-overlay :show="loading" no-wrap rounded></b-overlay>
			<b-col cols="12">
				<b-alert show variant="secondary">
					<pre>{{bookingInfo}}</pre>
				</b-alert>
			</b-col>
		</b-row>
	</section>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		index: Number,
        transportServiceId: {
            required: true,
            type: Number,
            default: -1,
        }
    },
	data() {
      return {
		loading: true,
		bookingInfo: [],
		showConfirmation:false,
		loadingConfirmation:false,
		apiType: '...',
		reference: '',
		bookingStatus: '',
		statusColor: 'success',
		cancelUser: '',
		cancelDatetime: '',

		supplierData: {
			id: -1,
			name: '',
			description: '',
			email: '',
			phone: '',
			photo_url: '',
		}
      }
    },
	methods: {
		getData() {
			this.loading = true

			this.$root.api.get(`/transport-services/api-data/${this.transportServiceId}`).then(res => {
				this.bookingInfo = res.data.booking
				this.apiType = res.data.apiType
				if(this.apiType !=='jayride'){
					return;
				}
				this.reference = res.data.reference
				this.bookingStatus = res.data.status
				this.supplierData = {...res.data.booking.service_info.supplier}
				this.cancelUser = res.data.cancelUser?.firstName
				this.cancelDatetime = res.data.cancelDatetime

				if(this.cancelDatetime != null) {
					this.cancelDatetime = moment(this.cancelDatetime).format("DD/MMMM/YYYY HH:mm:ss")
				}

				// color status
				if(this.bookingStatus == 'active') {
					this.statusColor = 'success'
				} else if(this.bookingStatus == 'canceled') {
					this.statusColor = 'danger'
				}

				this.showConfirmation    = false;
				this.loadingConfirmation = false;
			}).catch(this.$root.handleRequestError).then(()=>{
				this.loading = false
			});
		},
		cancelReservation() {
			this.showConfirmation    = true;
			this.loadingConfirmation = true;

			this.$root.api.post(`/transport-services/api-reservation/cancel/${this.transportServiceId}`).then(res => {
				this.$root.showAlert(res.data);
				this.getData()
			}).catch(this.$root.handleRequestError).then(()=>{
				this.showConfirmation    = false;
				this.loadingConfirmation = false;
			});
		}
	},
	mounted() {
		this.getData();
	},
};
</script>

<style scoped>
.badge {
	font-weight: normal;
}
.uppercase {
	text-transform: uppercase !important;
}
</style>
